import React, { useState, useEffect, useRef } from "react"
import {
  Container,
  Row,
  Card,
  CardBody,
  Col,
  Table,
  Button,
  Modal,
  CardTitle,
  Input,
  Label,
} from "reactstrap"
import moment from "moment"
import { connect } from "react-redux"
import { withRouter, Link } from "react-router-dom"
import * as _ from "lodash"
import Lightbox from "react-image-lightbox"
import "react-image-lightbox/style.css"

import Breadcrumb from "../../components/Common/Breadcrumb2"
import EditableColumn from "../Factory/EditableColumn"
import MwSelect from "../../components/Common/MwSelect"
import { fmtYNA } from "../../components/Common/reportPrintShared"
import { accessFlags, canValidateReport } from "../../common/accessFlags"
import ReportValidationControls from "../../components/Common/ReportValidation"
import { saveDailyMonitoringReport } from "../../store/daily-monitoring/action"
import Toaster from "../../components/Common/Toaster"
import * as backend from "../../helpers/backend_helper"
import * as func from "../../common/functions"
import BackButton from "../../common/ui/backButton"
import ConformationAlert from "../../common/ui/customAlert"
import ImageViewer from "../../common/ui/ImageViewer"
import { fileUrl } from "service";

const Options = [
  { label: "Yes", value: "yes:1" },
  { label: "No", value: "no:0" },
  { label: "NA", value: "na:1" },
]
const worker = "Workers Present"

const Report = (props: any) => {
  const [showSubmit, setShowSubmit] = useState(false)
  const [modal_standard, setmodal_standard] = useState(false)
  const [modal_data, setmodal_data] = useState<any>()
  const [formModal_data, setformModal_data] = useState<any>({})
  const [reports, setReports] = useState<any[]>([])
  const [images, setImages] = useState([])
  const [pressureLevel, setPressureLevel] = useState("0")
  const [totalworker, settotalworker] = useState(0)
  const [wokerpresentId, setwokerpresentId] = useState()
  const [first, setFirst] = useState(true)
  const [submitedBy, setSubmitedBy] = useState()
  const [submitedByuser, setSubmitedByUser] = useState()
  const [totalQuestions, settotalQuestions] = useState(0)
  const [overallscore, setoverallscore] = useState(0)
  const [totalQuestionInDepart, setTotalQuestionInDepart] = useState<any>()
  const [SubmitAlertVisible, setSubmitAlertVisible] = useState(false)
  const [remarks, setRemarks] = useState("")
  const [imageViewerData, setimageViewerData] = useState("")
  const [validation, setValidation] = useState<any>(null)
  const [downloading, setDownloading] = useState(false)
  const {
    match: {
      params: { month, year, day },
    },
  } = props

  // PDF is generated by the backend (headless Chrome) and downloaded directly —
  // no client-side print dialog.
  const downloadPdf = async () => {
    setDownloading(true)
    try {
      await backend.downloadReportPdf(
        props.selectedFactory.orgId,
        props.selectedFactory._id,
        "dailymonitoring",
        `${year}-${month}-${day}`,
        `Daily Monitoring - ${day}${month}${year}.pdf`
      )
    } catch (e) {
      Toaster.error(typeof e === "string" ? e : "Download failed")
    } finally {
      setDownloading(false)
    }
  }

  function tog_standard() {
    setmodal_standard(!modal_standard)
    removeBodyCss()
  }
  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }

  // column update
  function updateReport(obj, value, inputtype) {
    const cloneReports = [...reports]
    const findIndex = _.findIndex(cloneReports, obj)
    if (findIndex < 0) {
      cloneReports.push({ ...obj, value: value, type: inputtype })
    } else {
      cloneReports[findIndex].value = value
    }
    setReports([...cloneReports])
    if (wokerpresentId && obj.questionId == wokerpresentId)
      updateTotalWorkerPresent([...cloneReports])
    updateOverAllScore([...cloneReports])
  }

  function updateTotalWorkerPresent(dynamicReport) {
    try {
      const filter = _.filter(dynamicReport ? dynamicReport : reports, o => {
        return o.questionId == wokerpresentId && o.value
      }).map(o => Number(o.value))
      settotalworker(_.sum(filter))
    } catch (e) { }
  }
  // console.log("props", props)

  // update from Store
  useEffect(() => {
    if (props.dailymonitroingReport) {
      const { pressureLevel, report, submitedBy } = props.dailymonitroingReport
      if (pressureLevel) setPressureLevel(pressureLevel)
      if (report) setReports(report)
      if (submitedBy) setSubmitedBy(submitedBy)
      updateTotalWorkerPresent(report)
      updateOverAllScore(report)
    }
  }, [props.dailymonitroingReport, wokerpresentId])

  // update daily forms
  useEffect(() => {
    if (props.selectedFactory && props.selectedFactory.dailyMonitoringForm) {
      const firstGroup = props.selectedFactory.dailyMonitoringForm[0]
      const totalDepartment = props.selectedFactory.departments
        ? props.selectedFactory.departments.length
        : 0
      if (firstGroup) {
        const find = _.find(firstGroup.lists, o => {
          return o.name.toLowerCase().includes(worker.toLowerCase())
        })
        if (find) setwokerpresentId(find["_id"])
      }
      const totalNumberOfQuestionsArray = _.map(
        props.selectedFactory.dailyMonitoringForm,
        o => {
          return (
            _.filter(o.lists, f => f.type == "select").length * totalDepartment
          )
        }
      )
      const totalNumberOfQuestions = _.sum(totalNumberOfQuestionsArray)
      settotalQuestions(totalNumberOfQuestions)
    }
  }, [props.selectedFactory])

  // updateOverAllScore
  function updateOverAllScore(cloneReports) {
    try {
      // const submitedReports = _.filter(
      //   cloneReports ? cloneReports : reports,
      //   o => {
      //     const number = Number(o.value.split(":")[1])
      //     return o.type == "select" && number == 1
      //   }
      // ).length
      // const percetage = func.Percentage(totalQuestions, submitedReports)
      // if (percetage !== "NaN") {
      //   setoverallscore(percetage)
      // }
      let totalScore = 0
      {
        props.selectedFactory &&
          props.selectedFactory &&
          props.selectedFactory.departments &&
          props.selectedFactory.departments.map((depart, index) => {
            const dep = _.filter(cloneReports ? cloneReports : reports, {
              departmentId: depart["_id"],
              type: "select",
            })
              .map(d => d.value.split(":")[1])
              .filter(o => o == "1")
              .map(o => Number(o))
            let depScore = 0
            if (totalQuestionInDepart) {
              let depvalue: any = totalQuestionInDepart[depart["_id"]]
              // console.log("depvaluedepvalue",depvalue,totalQuestionInDepart);

              if (depvalue) {
                // Divisor = checkpoints actually recorded for this department,
                // never the current form count, so past scores stay stable when
                // the form is edited later.
                const recCount = _.filter(cloneReports ? cloneReports : reports, { departmentId: depart["_id"], type: "select" }).filter((r: any) => r.value).length
                depScore = recCount ? Math.round((10 * dep.length) / recCount) : 0
                totalScore = totalScore + depScore
                // console.log("totalScototalScoretotalScorere", totalScore)
              }
            }
          })
      }
      let finalValue = 0

      let NumberOfDepartments = props.selectedFactory.departments.length * 10
      finalValue = Number(((totalScore / NumberOfDepartments) * 100).toFixed(1))
      // console.log("ssssssssssssssssssssame", finalValue, totalScore)
      setoverallscore(Math.round(finalValue))
    } catch (e) { }
  }

  const getSubmitedUser = async userId => {
    const { orgId } = props.selectedFactory
    try {
      const response = await backend.getUserOrgById(orgId, userId)
      if (response) {
        setSubmitedByUser(response.name)
      }
    } catch (e) { }
  }
  // getDailyMonitoringReport
  async function getDailyMonitoringReport(image = false) {
    const { orgId, _id: facId } = props.selectedFactory
    try {
      const response = await backend.getdailymonitoringReport(
        orgId,
        facId,
        `${year}-${month}-${day}`
      )
      // console.log("response1111111111 first", response)

      if (response) {
        // console.log("response1111111111", response)

        setValidation(response.validation || null)
        if (response.images) {
          setImages(response.images)
        }
        if (response.submitedBy && !image) {
          // console.log("response get in", response)

          const saveObject = {
            pressureLevel: response.pressureLevel,
            report: response.report,
            submitedBy: response.submitedBy,
            remarks: response.remarks,
          }
          setRemarks(response.remarks)
          getSubmitedUser(response.submitedBy)
          setShowSubmit(false)
          props.saveDailyMonitoringReport(saveObject, `${year}-${month}-${day}`)
        } else {
          setShowSubmit(!props.readOnly)
        }
      } else {
        setShowSubmit(!props.readOnly)
      }

      if (props.isAdmin) {
        setShowSubmit(!props.readOnly)
      }
    } catch (e) {
      console.log(e)
    }
  }
  useEffect(() => {
    if (first && props.selectedFactory) {
      getDailyMonitoringReport()
      let data = func.getTotalQuestionsindailyMonitoringReport(
        props.selectedFactory.dailyMonitoringForm,
        props.selectedFactory.departments
      )
      setTotalQuestionInDepart(data)
      setFirst(false)
    }
  }, [first, props.selectedFactory])

  // submit button
  async function submit(reports, pressureLevel) {
    if (!props.isAdmin) {
      toggleAlert()
    }

    const { orgId, _id: facId } = props.selectedFactory
    const obj = {
      report: reports,
      pressureLevel: pressureLevel,
      submitedBy: props.user["_id"],
      remarks: remarks,
    }
    try {
      await backend.savedailymonitoringReport(
        orgId,
        facId,
        `${year}-${month}-${day}`,
        obj
      )
      getDailyMonitoringReport()
      // setRemarks("")
      Toaster.success("Report Submitted successfully")
    } catch (e) {
      Toaster.error("Report Submitted Failed")
    }
  }
  // save button
  function save() {
    const saveObject = {
      pressureLevel: pressureLevel,
      report: reports,
    }
    props.saveDailyMonitoringReport(saveObject, `${year}-${month}-${day}`)
    Toaster.success("Work Saved Successfully")
  }

  //uploadImage
  async function uploadImage() {
    const { orgId, _id: facId } = props.selectedFactory
    const { departmentId, groupId, questionId } = modal_data

    if (!formModal_data.file || !formModal_data.file[0]) {
      Toaster.error("Please choose a file")
      return
    }

    const formData = new FormData()
    // Update the formData object
    _.each(formModal_data.file, file => {
      formData.append("image", file)
    })
    formData.append("desc", formModal_data.desc || '')
    formData.append("departmentId", departmentId)
    formData.append("groupId", groupId)
    formData.append("questionId", questionId)
    formData.append("date", `${year}-${month}-${day}`)
    try {
      await backend.uploadMonthlyMonitoringReport(orgId, facId, formData)
      getDailyMonitoringReport(true)
      tog_standard()
      Toaster.success("Image uploaded successfully")
    } catch (e) {
      Toaster.error(typeof e === "string" ? e : "Image upload failed")
    }
  }
  const submitedUser = submitedByuser
    ? submitedByuser
    : props.user && props.user.name

  if (!props.selectedFactory) {
    return <></>
  }

  const onSubmit = async () => {
    // Marking the day as Weekly Off / Holiday / Audit (a remark) submits no
    // answers, so it is exempt from the "answer everything" rule.
    const isRemark = props.isAdmin && remarks
    if (!isRemark) {
      // Every checkpoint (select question × department) must be answered before
      // the Onsite Inspection report can be submitted.
      const answered = reports.filter((r: any) => r.type === "select" && r.value).length
      if (totalQuestions > 0 && answered < totalQuestions) {
        Toaster.warning(
          `Please answer all questions before submitting (${answered} of ${totalQuestions} answered).`
        )
        return
      }
    }
    if (props.isAdmin) {
      if (remarks) {
        submit([], "0")
      } else {
        submit(reports, pressureLevel)
      }
    } else {
      toggleAlert()
    }
  }

  const toggleAlert = () => {
    setSubmitAlertVisible(!SubmitAlertVisible)
  }
  const deleteImage = (e, img) => {
    e.stopPropagation()

    const { orgId, _id: facId } = props.selectedFactory
    console.log("imgimgimg", img, orgId, facId)
    let data = {
      date: `${year}-${month}-${day}`,
      imageId: img._id,
    }
    backend
      .deleteImage(orgId, facId, data)
      .then(() => {
        console.log("Sucess")

        getDailyMonitoringReport(true)
      })
      .catch(() => {
        console.log("error in delete")
      })
  }

  let aboutDay = {
    W: "Weekly Off (W)",
    H: "Holiday (H)",
    A: "Audit (A)",
  }
  let date = `${year}-${month}-${day}`

  let todayDate = moment().format("YYYY-MM-DD")
  // console.log(
  //   "todayDatetodayDatetodayDate",
  //   todayDate,
  //   date,
  //   date === todayDate
  // )
  let isToday = date === todayDate
  // Can the user edit THIS report? Admin/editor, or a member with the Daily
  // Onsite permission. Gates photo delete so a user without edit rights can't.
  const _dmPerm: string[] = (props.selectedFactory && props.selectedFactory.permission) || []
  const canEditDaily = _dmPerm.includes("ADMIN") || _dmPerm.includes("EDIT") || _dmPerm.includes("Daily_onSiteInspection")
  // console.log("totalworkertotalworkertotalworkertotalworker",totalworker);

  // Configured per-checkpoint totals (sum across departments), shown as header
  // chips for checkpoints with "Show Total in Header" enabled in the form config.
  const totalChips = _.flatten(
    _.map((props.selectedFactory && props.selectedFactory.dailyMonitoringForm) || [], "lists")
  )
    .filter((q: any) => q && q.showTotal)
    .map((q: any) => {
      const total = reports
        .filter((r: any) => String(r.questionId) === String(q._id))
        .reduce((s: number, r: any) => {
          const str = String(r.value == null ? "" : r.value)
          const n = str.includes(":") ? Number(str.split(":")[1]) : Number(str)
          return s + (isNaN(n) ? 0 : n)
        }, 0)
      return { name: q.name, total }
    })

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="mw-detail-header">
            <button
              type="button"
              className="mw-back-btn"
              title="Back"
              onClick={() => props.history.goBack()}
            >
              <i className="mdi mdi-arrow-left" />
            </button>
            <div className="mw-detail-titles">
              <div className="mw-crumb">
                <Link to="/daily-monitoring">{year}</Link>
                <span className="mw-crumb-sep">/</span>
                <Link to={`/daily-monitoring/${year}/${month}`}>
                  {moment(month, "MM").format("MMMM")}
                </Link>
                <span className="mw-crumb-sep">/</span>
                <span className="mw-crumb-current">Day {day}</span>
              </div>
              <h4>
                Daily Report — {moment(`${year}-${month}-${day}`, "YYYY-MM-DD").format("DD MMM YYYY")}
              </h4>
              <p>Record Daily Monitoring Checkpoints by Department</p>
            </div>
          </div>
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  {/* Clean two-zone header: left = who submitted + Print;
                      right = overall score with Day Remarks + Confirm grouped
                      below. Even spacing, no cramped stacking or empty columns. */}
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                      gap: "20px",
                    }}
                  >
                    {/* Left zone */}
                    <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                      <span style={{ display: "flex", alignItems: "center" }}>
                        <h4 style={{ margin: 0 }}>Submit By :</h4>
                        <p style={{ padding: "0 6px", margin: 0, fontWeight: 700, color: "#1D3A5F" }}>
                          {submitedUser}
                        </p>
                      </span>
                      {submitedBy && (
                        <Button
                          onClick={downloadPdf}
                          color="success"
                          disabled={downloading}
                          style={{ alignSelf: "flex-start" }}
                        >
                          {downloading ? "Preparing…" : "Download PDF"}
                        </Button>
                      )}
                      {/* Admin review: Validate / Reject; status badge for all */}
                      <ReportValidationControls
                        reportType="dailymonitoring"
                        dateKey={`${year}-${month}-${day}`}
                        orgId={props.selectedFactory.orgId}
                        facId={props.selectedFactory._id}
                        validation={validation}
                        isAdmin={canValidateReport(props.selectedFactory, props.user, "dailymonitoring", submitedBy)}
                        submitted={!!submitedBy}
                        by={{ id: props.user && props.user["_id"], name: props.user && props.user.name }}
                        onChange={setValidation}
                      />
                    </div>

                    {/* Right zone */}
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: "14px" }}>
                      <span style={{ display: "flex", alignItems: "center" }}>
                        <h4 style={{ margin: 0 }}>Score:</h4>
                        <p style={{ padding: "0 6px", margin: 0, fontWeight: 700, fontSize: "22px", color: "#1D3A5F" }}>
                          {overallscore}
                        </p>
                      </span>
                      <div style={{ display: "flex", alignItems: "flex-end", gap: "12px" }}>
                        <div style={{ minWidth: 240, textAlign: "left" }}>
                          <Label
                            for="horizontal-email-Input"
                            className="col-form-Label"
                            style={{ padding: 0, marginBottom: "6px", display: "block" }}
                          >
                            Day Remarks
                          </Label>
                          <MwSelect
                            value={remarks || ""}
                            onChange={(val: any) => setRemarks(val)}
                            options={[
                              { value: "", label: "Working day (no remark)" },
                              ...Object.keys(aboutDay).map(key => ({
                                value: key,
                                label: aboutDay[key],
                              })),
                            ]}
                          />
                        </div>
                        {showSubmit && (
                          <Button onClick={onSubmit} color="success">
                            Confirm
                          </Button>
                        )}
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {totalChips.length > 0 && (
            <Row>
              <Col lg={12}>
                <div style={{ display: "flex", flexWrap: "wrap", gap: 12, justifyContent: "flex-end", marginBottom: 16 }}>
                  {totalChips.map((c: any, i: number) => (
                    <div key={i} style={{ border: "1px solid #cdd5dd", borderRadius: 8, padding: "6px 18px", textAlign: "center", minWidth: 96, background: "#fff" }}>
                      <div style={{ fontSize: 20, fontWeight: 800, color: "#1D3A5F" }}>{c.total}</div>
                      <div style={{ fontSize: 10, color: "#667", textTransform: "uppercase", letterSpacing: ".5px" }}>{c.name}</div>
                    </div>
                  ))}
                </div>
              </Col>
            </Row>
          )}
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <div
                    className="table-responsive"
                    style={{ overflowY: "auto", height: "65vh" }}
                  >
                    <Table
                      className="table table-hover table-bordered mb-0"
                      style={{ borderCollapse: "separate", borderSpacing: 0 }}
                    >
                      <thead>
                        <tr className="table-success">
                          <th
                            style={{
                              position: "sticky",
                              top: "0",
                              // background: "#ffff",
                              zIndex: 1,
                              borderTop: "1px solid #eff2f7",
                              borderBottom: "1px solid #eff2f7",
                            }}
                          >
                            CheckPoints
                          </th>
                          {props.selectedFactory &&
                            props.selectedFactory &&
                            props.selectedFactory.departments &&
                            props.selectedFactory.departments.map(
                              (depart, deIndex) => {
                                return (
                                  <th
                                    style={{
                                      position: "sticky",
                                      top: "0",
                                      // background: "#ffff",
                                      zIndex: 1,
                                      borderTop: "1px solid #eff2f7",
                                      borderBottom: "1px solid #eff2f7",
                                    }}
                                    key={deIndex}
                                  >
                                    {depart.name}
                                  </th>
                                )
                              }
                            )}
                        </tr>
                      </thead>
                      <tbody>
                        {props.selectedFactory &&
                          props.selectedFactory &&
                          props.selectedFactory.departments &&
                          props.selectedFactory.dailyMonitoringForm &&
                          props.selectedFactory.dailyMonitoringForm.map(
                            (group, groupIndex) => {
                              return (
                                <React.Fragment key={groupIndex}>
                                  <tr
                                    key={groupIndex}
                                    style={{ textAlign: "center" }}
                                  >
                                    <th
                                      colSpan={
                                        props.selectedFactory.departments
                                          .length + 1
                                      }
                                      scope="row"
                                    >
                                      {group.name}
                                    </th>
                                  </tr>
                                  {group.lists.map((question, qIndex) => {
                                    return (
                                      <tr key={qIndex}>
                                        <th scope="row">{question.name}</th>
                                        {props.selectedFactory.departments.map(
                                          (depart, deIndex) => {
                                            const obj = {
                                              groupId: group["_id"],
                                              questionId: question["_id"],
                                              departmentId: depart["_id"],
                                            }
                                            const find = _.find(reports, obj)
                                            return (
                                              <td key={deIndex}>
                                                {showSubmit ? (
                                                  <EditableColumn
                                                    update={value =>
                                                      updateReport(
                                                        obj,
                                                        value,
                                                        question.type
                                                      )
                                                    }
                                                    options={Options}
                                                    placeholder={" "}
                                                    type={question.type}
                                                    value={
                                                      find && find.value
                                                        ? find.value
                                                        : null
                                                    }
                                                  />
                                                ) : (
                                                  <p style={{ textAlign: "center", margin: 0 }}>
                                                    {find && find.value
                                                      ? fmtYNA(find.value.split(":")[0])
                                                      : null}
                                                  </p>
                                                )}
                                                <br />
                                                {find &&
                                                  find.value == "no:0" &&
                                                  showSubmit && (
                                                    <button
                                                      onClick={e => {
                                                        setmodal_data(find)
                                                        setformModal_data({})
                                                        tog_standard()
                                                      }}
                                                      style={{
                                                        padding: "2px 20px",
                                                        margin: "0 auto",
                                                        display: "block",
                                                      }}
                                                      type="button"
                                                      className="btn btn-danger waves-effect waves-light"
                                                    >
                                                      <i className="mdi mdi-upload d-block font-size-16"></i>{" "}
                                                    </button>
                                                  )}
                                              </td>
                                            )
                                          }
                                        )}
                                      </tr>
                                    )
                                  })}
                                </React.Fragment>
                              )
                            }
                          )}
                        <tr>
                          <th scope="row">Score</th>
                          {props.selectedFactory &&
                            props.selectedFactory &&
                            props.selectedFactory.departments &&
                            props.selectedFactory.departments.map(
                              (depart, index) => {
                                const dep = _.filter(reports, {
                                  departmentId: depart["_id"],
                                  type: "select",
                                })
                                  .map(d => d.value.split(":")[1])
                                  .filter(o => o == "1")
                                  .map(o => Number(o))
                                let depScore = 0
                                if (totalQuestionInDepart) {
                                  let depvalue =
                                    totalQuestionInDepart[depart["_id"]]
                                  // console.log("depvaluedepvalue",depvalue,totalQuestionInDepart);

                                  if (depvalue) {
                                    // Divisor = checkpoints actually recorded for
                                    // this department (immune to later form edits).
                                    const recCount = _.filter(reports, { departmentId: depart["_id"], type: "select" }).filter((r: any) => r.value).length
                                    depScore = recCount ? Math.round((10 * dep.length) / recCount) : 0
                                  }
                                }
                                return <td key={index}>{depScore}</td>
                              }
                            )}
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      padding: "10px",
                    }}
                  >
                    {(isToday || props.isAdmin) && (
                      <React.Fragment>
                        {!submitedBy && (
                          <Button
                            style={{ marginLeft: "2px", marginRight: "2px" }}
                            onClick={save}
                            color="primary"
                          >
                            Save
                          </Button>
                        )}
                        {showSubmit && (
                          <Button
                            style={{ marginLeft: "2px", marginRight: "2px" }}
                            onClick={onSubmit}
                            color="success"
                          >
                            Submit
                          </Button>
                        )}
                      </React.Fragment>
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {/* here Show Images start */}
          <Row>
            <Col md={12}>
              <Card>
                <CardBody>
                  <CardTitle style={{ paddingLeft: "8px" }}>
                    Remarks (Enclose Evidences)
                  </CardTitle>
                  <div
                    className="popup-gallery"
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    {props.selectedFactory &&
                      props.selectedFactory &&
                      props.selectedFactory.departments &&
                      props.selectedFactory.departments.map((depart, key) => {
                        const find1 = _.find(images, {
                          departmentId: depart._id,
                        })

                        // console.log("departdepartdepart12345",find1 && find1.departmentId===depart._id,find1 ,depart._id)
                        return (
                          <React.Fragment key={key}>
                            <div style={{ display: "flex", flexWrap: "wrap", gap: "14px", alignItems: "flex-start", marginBottom: find1 ? "16px" : 0 }}>
                              {images.length > 0 && find1 && (
                                <div
                                  style={{ width: "100%", fontWeight: 700, color: "#1D3A5F", borderLeft: "4px solid #2EA99B", padding: "2px 0 2px 10px" }}
                                >
                                  {depart.name}
                                </div>
                              )}
                              {images &&
                                images.map((image, key) => {
                                  // console.log("imageimages", image, images)
                                  const find: any = _.find([image], {
                                    departmentId: depart._id,
                                  })

                                  if (find) {
                                    return (
                                      <div
                                        style={{
                                          width: "200px",
                                          border: "1px solid #dfe6ee",
                                          borderRadius: "8px",
                                          overflow: "hidden",
                                          background: "#fff",
                                          position: "relative",
                                        }}
                                        key={key}
                                      >
                                        {find.img && (
                                          <React.Fragment>
                                            {showSubmit && canEditDaily && (
                                            <button
                                              type="button"
                                              title="Remove"
                                              onClick={e => {
                                                deleteImage(e, image)
                                              }}
                                              style={{
                                                position: "absolute",
                                                top: "6px",
                                                right: "6px",
                                                border: "none",
                                                background: "rgba(0,0,0,0.55)",
                                                color: "#fff",
                                                borderRadius: "50%",
                                                width: "22px",
                                                height: "22px",
                                                lineHeight: 1,
                                                cursor: "pointer",
                                              }}
                                            >
                                              &times;
                                            </button>
                                            )}
                                            <img
                                              style={{ cursor: "pointer", width: "100%", height: "150px", objectFit: "cover", display: "block" }}
                                              src={find.img.id ? fileUrl(find.img.id) : `data:${find.img.contentType};base64, ${find.img.data}`}
                                              onClick={e => {
                                                setimageViewerData(
                                                  find.img.id ? fileUrl(find.img.id) : `data:${find.img.contentType};base64, ${find.img.data}`
                                                )
                                              }}
                                              alt=""
                                            />
                                            {find.desc && (
                                              <p
                                                style={{
                                                  margin: 0,
                                                  padding: "6px 8px",
                                                  fontSize: "12px",
                                                  color: "#333",
                                                  background: "#f7fafc",
                                                  maxHeight: "64px",
                                                  overflow: "auto",
                                                }}
                                              >
                                                {find.desc}
                                              </p>
                                            )}
                                          </React.Fragment>
                                        )}
                                      </div>
                                    )
                                  }

                                  // {/* {images &&
                                  //   images.map((image, key) => {
                                  //     console.log("image", image, reports)

                                  //     const find = _.find(reports, {
                                  //       departmentId: image.departmentId,
                                  //       groupId: image.groupId,
                                  //       questionId: image.questionId,
                                  //     })
                                  //     console.log("find", find)
                                  //     if (!find || (find && find.value != "no:0")) {
                                  //       return <React.Fragment key={key}></React.Fragment>
                                  //     }
                                  //     return (
                                  //       <div
                                  //         className="img-fluid float-left"
                                  //         style={{
                                  //           padding: "10px",
                                  //           margin: "12px",
                                  //           height: "245px",
                                  //           width: "180px",
                                  //           backgroundColor: "rgb(250, 250, 250)",
                                  //           border: "1px dashed black",
                                  //         }}
                                  //         key={key}
                                  //       >
                                  //         {image.img && (
                                  //           <React.Fragment>
                                  //             <div
                                  //               onClick={e => {
                                  //                 deleteImage(e, image)
                                  //               }}
                                  //               style={{
                                  //                 float: "right",
                                  //                 margin: "-2px",
                                  //                 cursor: "pointer",
                                  //               }}
                                  //             >
                                  //               <i class="mdi mdi-close-thick"></i>
                                  //             </div>
                                  //             <img
                                  //               width="150px"
                                  //               height="150px"
                                  //               src={`data:${image.img.contentType};base64, ${image.img.data}`}
                                  //               onClick={() => {
                                  //                 // setisGallery(true)
                                  //                 // setphotoIndex(0)
                                  //               }}
                                  //               alt=""
                                  //               // width="120"
                                  //             />
                                  //             {image.desc && <p> {image.desc} </p>}
                                  //           </React.Fragment>
                                  //         )}
                                  //       </div>
                                  //     )
                                  //   })} */}
                                })}
                            </div>
                          </React.Fragment>
                        )
                      })}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {/* here Show Images stop */}
        </Container>
      </div>
      {imageViewerData && (
        <ImageViewer
          image={imageViewerData}
          close={() => {
            setimageViewerData("")
          }}
        />
      )}
      <ConformationAlert
        visible={SubmitAlertVisible}
        Title={"Alert"}
        Message={"If you submit you can't do any changes in the report"}
        toggleAlert={toggleAlert}
        Submit={() => {
          if (remarks) {
            submit([], "0")
          } else {
            submit(reports, pressureLevel)
          }
        }}
      />
      <Modal
        isOpen={modal_standard}
        toggle={() => {
          tog_standard()
        }}
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myModalLabel">
            {"Upload Documents"}
          </h5>
          <button
            type="button"
            onClick={() => {
              setmodal_standard(false)
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <div className="form-group">
            <input
              type="text"
              className="form-control"
              onChange={event =>
                setformModal_data({
                  ...formModal_data,
                  desc: event.target.value,
                })
              }
              placeholder="description"
            />
          </div>
          <div className="custom-file">
            <input
              type="file"
              multiple
              accept="image/jpeg, image/png"
              className="custom-file-input"
              id="customFile"
              onChange={event => {
                setformModal_data({
                  ...formModal_data,
                  file: event.target.files,
                  // imagePreview: URL.createObjectURL(event.target.files[0]),
                })
              }}
            />
            <label className="custom-file-label" htmlFor="customFile">
              {formModal_data && formModal_data.file && formModal_data.file[0]
                ? formModal_data.file[0].name
                : "Choose file"}
            </label>
          </div>
          {/* formModal_data.file && formModal_data.file.length */}
          {/* {formModal_data && formModal_data.file &&
            formModal_data.file.length > 0 && formModal_data.file.map(list => {
              console.log("list123456",list);
              
              return (
                <label className="custom-file-label" htmlFor="customFile">
                  {list.name}
                </label>
              )
            })} */}
        </div>

        <div className="modal-footer">
          <button
            type="button"
            onClick={() => {
              tog_standard()
            }}
            className="btn btn-secondary waves-effect"
            data-dismiss="modal"
          >
            Close
          </button>
          <button
            type="button"
            onClick={() => {
              uploadImage()
            }}
            className="btn btn-primary waves-effect waves-light"
          >
            Save
          </button>
        </div>
      </Modal>
    </React.Fragment>
  )
}
const mapStateToProps = (state, props) => {
  const {
    match: {
      params: { month, year, day },
    },
  } = props
  const { user } = state.user
  const { selected: selectedFactory } = state.factory
  const {
    dailymonitroing: { [`${year}-${month}-${day}`]: dailymonitroingReport },
  } = state.dailymonitroing
  const flags = accessFlags(selectedFactory)
  return { selectedFactory, user, ...flags, dailymonitroingReport }
}

export default withRouter(
  connect(mapStateToProps, { saveDailyMonitoringReport })(Report)
)
